import { forwardRef } from 'react';
import { ChartHR } from '@/entities/heart-rate';
import SelectedInfo from '@/widgets/hr-summary/ui/selectedInfo';
import useDailySummaryHrChart from './useDailySummaryHrChart';

export type HrChartProps = {
  ecgDataMap: any;
  timezoneOffset?: number;
  studyId?: any;
  profileId?: any;
};

export type HrChartRef = {
  handleClickArrowButton: (isNext?: boolean) => void;
};

/**
 * Renders the heart-rate chart of the daily summary view together with its selected-info strip. Feeds the chart data from useDailySummaryHrChart into ChartHR in old-UI daily-summary mode at a fixed minimum width, with the forwarded ref bridged to the chart handle.
 *
 * @param props - Chart inputs including the timezone offset applied to the chart and the selected-info panel.
 * @param ref - Forwarded handle the parent uses to drive the chart imperatively.
 * @returns The daily summary heart-rate chart followed by its selected-info panel.
 */
const HrChart = forwardRef<HrChartRef, HrChartProps>(
  ({ ecgDataMap, timezoneOffset, studyId, profileId }, ref) => {
    const { keyRecoil, chartHrRef, dataChart } = useDailySummaryHrChart(
      { ecgDataMap, timezoneOffset, studyId, profileId },
      ref,
    );

    return (
      <>
        <ChartHR
          ref={chartHrRef}
          idHtmlChart="mct-daily-summary-hr-chart-container"
          keyRecoil={keyRecoil}
          dataChart={dataChart}
          timezoneOffset={timezoneOffset}
          isOldUI
          isDailyHrSummary
          minWidth={945}
        />
        <SelectedInfo timezoneOffset={timezoneOffset} isDailyHrSummary />
      </>
    );
  },
);

export default HrChart;
